// extracted by mini-css-extract-plugin
module.exports = {"brand-color-text":"style_brand-color-text__2MbVi","radio-label":"style_radio-label__2U04X"};